export const classificationPackage = [
  "U.S. Standard Industrial Classification 1987",
  "NAICS"
]